import React, { useState, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  Input,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { fetchCountryCurrency } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";

const PayRateElement = ({ formik, field, formStateHook }) => {
  const { formState } = formStateHook;
  const payrate = ["Hourly", "Daily", "Weekly", "Monthly", "Yearly"];
  const dispatch = useDispatch();
  const countryData = useSelector(
    (state) => state.CountryCurrencyReducer.countryCurrency
  );

  // Currency & Filter
  const [currencyDropdown, setCurrencyDropdown] = useState(false);
  const [payRateDropdown, setPayRateDropdrown] = useState(false);

  const [selectedCurrency, setSelectedCurrency] = useState("SGD");
  const [selectedPayRate, setSelectedPayRate] = useState("Monthly");
  const [payRateInput, setPayRateInput] = useState();

  //Search element
  const [currencySearchTerm, setCurrencySearchTerm] = useState();
  const [payRateSearchTerm, setPayRateSearchTerm] = useState();
  const [dataLoaded, setDataLoaded] = useState(false);

  // Fetch country currency
  useEffect(() => {
    if (!countryData) {
      dispatch(fetchCountryCurrency());
    }
  }, []);

  useEffect(() => {
    if (!dataLoaded && formik?.values?.[field?.name]) {
      const value = formik?.values?.[field?.name];
      if (typeof value == "string" && value.indexOf(" ") > 0) {
        const data = value?.split(" ");
        if (data?.length > 1 && data?.[1]?.length === 3) {
          setPayRateInput(data?.[0] ?? "");
          setSelectedCurrency(data?.[1] ?? "SGD");
          setSelectedPayRate(data?.[2] ?? "Monthly");
        } else {
          setPayRateInput(value);
        }
      } else {
        setPayRateInput(value);
      }
      setDataLoaded(true);
    }
  }, [formik?.values?.[field?.name]]);

  useEffect(() => {
    const input = payRateInput;
    if (selectedCurrency && selectedPayRate && input) {
      const value = `${input} ${selectedCurrency} ${selectedPayRate}`;
      formik?.setFieldValue(field.name, value);
    }
  }, [selectedCurrency, selectedPayRate, payRateInput]);

  const togglePayRateDropdown = () =>
    setPayRateDropdrown((prevState) => !prevState);

  const toggleCurrencyDropdown = () =>
    setCurrencyDropdown((prevState) => !prevState);

  const filteredPayRate = payRateSearchTerm
    ? payrate.filter((data) => {
        let payRate = `${data}`;
        return payRate.toLowerCase().includes(payRateSearchTerm.toLowerCase());
      })
    : payrate;

  const filteredCurrencies = currencySearchTerm
    ? countryData?.filter((country) => {
        let currency = `${country.currency} ${country.name}`;
        return currency
          .toLowerCase()
          .includes(currencySearchTerm.toLowerCase());
      })
    : countryData;

  return (
    <div className="input-group">
      {formState === "view" ? (
        <p className="fw-semibold me-1">
          {payRateInput != "" ? payRateInput : <span>{field.placeholder}</span>}
        </p>
      ) : (
        <Input
          // type="number"
          className="form-control rounded"
          style={{ borderColor: "#d3d3d3" }}
          defaultValue={payRateInput}
          name={field.name}
          placeholder={field.placeholder}
          onChange={(e) => setPayRateInput(e.target.value)}
          disabled={formState === "view" ? true : false}
        />
      )}

      <Dropdown
        className="dropdown"
        isOpen={currencyDropdown}
        toggle={toggleCurrencyDropdown}
        tabIndex="1"
      >
        <DropdownToggle
          as="button"
          className="btn btn-light arrow-none"
          style={{
            border: formState === "view" ? "none" : "1px solid #d3d3d3",
            backgroundColor: formState === "view" && "#fff",
            padding: formState === "view" && "0px",
            fontWeight: formState === "view" && "500",
            color: formState === "view" && "#000",
            display: "inline",
          }}
          disabled={formState === "view" ? true : false}
          tabIndex={2}
        >
          <span className="me-1">{selectedCurrency}</span>
        </DropdownToggle>
        <DropdownMenu
          as="ul"
          className="list-unstyled w-200 dropdown-menu-list mb-0 overflow-auto"
          style={{ maxHeight: "240px" }}
        >
          <Input
            type="text"
            className="form-control search m-auto"
            placeholder="Search currency..."
            value={currencySearchTerm}
            style={{ borderColor: "#d3d3d3" }}
            onChange={(e) => setCurrencySearchTerm(e.target.value)}
          />
          {filteredCurrencies &&
            filteredCurrencies.map((country) => (
              <DropdownItem
                key={country.id}
                as="li"
                onClick={() => setSelectedCurrency(country.currency)}
                className="dropdown-item d-flex"
              >
                <div className="flex-grow-1">
                  <div className="d-flex">
                    <span>
                      {country.currency} {country.currencySymbol}{" "}
                      {`(${country.name})`}
                    </span>
                  </div>
                </div>
              </DropdownItem>
            ))}
        </DropdownMenu>
      </Dropdown>
      <Dropdown
        className="dropdown"
        isOpen={payRateDropdown}
        toggle={togglePayRateDropdown}
        tabIndex="1"
      >
        <DropdownToggle
          as="button"
          className="btn btn-light arrow-none"
          style={{
            border: formState === "view" ? "none" : "1px solid #d3d3d3",
            backgroundColor: formState === "view" && "#fff",
            padding: formState === "view" && "0px",
            fontWeight: formState === "view" && "500",
            color: formState === "view" && "#000",
          }}
          disabled={formState === "view" ? true : false}
        >
          <span>{selectedPayRate}</span>
        </DropdownToggle>
        <DropdownMenu
          as="ul"
          className="list-unstyled w-100 dropdown-menu-list mb-0 overflow-auto"
          style={{ maxHeight: "240px" }}
        >
          <Input
            type="text"
            className="form-control search m-auto"
            placeholder="Search frequency..."
            value={payRateSearchTerm}
            style={{ borderColor: "#d3d3d3" }}
            onChange={(e) => setPayRateSearchTerm(e.target.value)}
          />
          {filteredPayRate &&
            filteredPayRate.map((payRate) => (
              <DropdownItem
                key={payRate}
                as="li"
                onClick={() => setSelectedPayRate(`${payRate}`)}
                className="dropdown-item d-flex"
              >
                <div className="flex-grow-1">
                  <div className="d-flex">
                    <span>{payRate}</span>
                  </div>
                </div>
              </DropdownItem>
            ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default PayRateElement;
